import { createApi } from '@reduxjs/toolkit/query/react';
import { buildBaseQuery } from 'app/api';
import { DeviceLookup } from './types';

const name = 'deviceApi';

export const devicesApi = createApi({
  reducerPath: name,
  baseQuery: buildBaseQuery('api/devices'),
  endpoints: (builder) => ({
    // Anonymous: which kind of device a QR sticker code is on (404 when none).
    getDeviceType: builder.query<DeviceLookup, string>({
      query: (barcode) => `/${encodeURIComponent(barcode)}`,
    }),
  }),
  refetchOnMountOrArgChange: true,
});

export const {
  useGetDeviceTypeQuery,
} = devicesApi;
